import { useEffect } from "react";

const OVERLAY_SELECTOR = '[data-testid="ad-break-overlay"]';

const postToIframe = (iframe, mute) => {
  try {
    const win = iframe.contentWindow;
    if (!win) return;
    win.postMessage(JSON.stringify({ event: "command", func: mute ? "mute" : "unMute", args: "" }), "*");
    win.postMessage(JSON.stringify({ type: mute ? "mute" : "unmute" }), "*");
  } catch {}
};

// Mutes every broadcast <video>/<audio>/<iframe> inside containerRef while active; restores afterwards.
export const useAdBreakMute = (containerRef, active) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!active || !container) return;
    const prevMuted = new Map();
    const touchedIframes = new Set();

    const muteAll = () => {
      container.querySelectorAll("video, audio").forEach((el) => {
        if (el.closest(OVERLAY_SELECTOR)) return;
        if (!prevMuted.has(el)) prevMuted.set(el, el.muted);
        if (!el.muted) el.muted = true;
      });
      container.querySelectorAll("iframe").forEach((el) => {
        if (el.closest(OVERLAY_SELECTOR)) return;
        touchedIframes.add(el);
        postToIframe(el, true);
      });
      const fs = document.fullscreenElement || document.webkitFullscreenElement;
      if (fs && container.contains(fs) && !fs.querySelector(OVERLAY_SELECTOR)) {
        (document.exitFullscreen || document.webkitExitFullscreen)?.call(document)?.catch?.(() => {});
      }
    };

    muteAll();
    const interval = setInterval(muteAll, 1000);
    return () => {
      clearInterval(interval);
      prevMuted.forEach((wasMuted, el) => { if (el.isConnected) el.muted = wasMuted; });
      touchedIframes.forEach((el) => { if (el.isConnected) postToIframe(el, false); });
    };
  }, [containerRef, active]);
};
